import type { PartnerHotelOutOfCatalogSummary } from "@/types/partner-order";

/**
 * Money rule (owner, DV-68): Booked is the provider-side order amount;
 * Revenue (commission) is the whole Viator commission; Earned/Expected is
 * the hotel/tenant share of that commission.
 *
 * Input is either the orders summary (`partnerRevenue` = commission,
 * `totalRevenue` = booked) or the total-revenue summary (`totalRevenue` =
 * commission, no `partnerRevenue`).
 */
export interface PartnerSummaryMoneyInput {
  totalRevenue: number;
  partnerRevenue?: number;
  totalBooked: number;
  earnings: number;
  pendingEarnings: number;
  currency: string;
  outOfCatalog: PartnerHotelOutOfCatalogSummary;
}

export interface PartnerSummaryMoney {
  booked: number;
  revenue: number;
  earnings: number;
  expected: number;
  currency: string;
  bookedOutside: {
    count: number;
    booked: number;
    commission: number;
    earnings: number;
  };
}

export function mapPartnerSummaryMoney(
  summary: PartnerSummaryMoneyInput,
): PartnerSummaryMoney {
  return {
    booked: summary.totalBooked,
    revenue: summary.partnerRevenue ?? summary.totalRevenue,
    earnings: summary.earnings,
    expected: summary.pendingEarnings,
    currency: summary.currency,
    bookedOutside: {
      count: summary.outOfCatalog.count,
      booked: summary.outOfCatalog.booked,
      commission: summary.outOfCatalog.revenue,
      earnings: summary.outOfCatalog.earnings,
    },
  };
}
